import styled from "styled-components";

export const AppContainer = styled.div`
  min-height: 100vh;
  background: #0D0D0D;
  --angle: 0deg;
  --start-angle: 0deg;
  @property --angle {
    syntax: "<angle>";
    inherits: false;
    initial-value: 0deg;
  }
  @media screen and (max-width: 767px) {
    overflow: hidden;
  }
`;
